 export class ReservationV2ServiceValidator {
   static validateReservationData(reservationData: any): boolean {
      return reservationData && reservationData.hotelReservation
        && reservationData.hotelReservation.hotels && reservationData.hotelReservation.hotels[0]
        && reservationData.hotelReservation.reservationIds && reservationData.hotelReservation.reservationIds.confirmationNumbers
        && reservationData.hotelReservation.userProfiles && reservationData.hotelReservation.userProfiles[0]
   }

   static validateRateRulesData(rateRulesData: any): boolean {
     return rateRulesData
       && rateRulesData.room
       && rateRulesData.rate;
   }

   static validateAvailSinglePropData(availBody: any): boolean {
    return availBody
      && availBody.hotels
      && availBody.hotels[0]
      && availBody.hotels[0].rateDetails
      && availBody.hotels[0].rateDetails.offers
      && availBody.hotels[0].rateDetails.offers[0]
      && availBody.hotels[0].rateDetails.offers[0].availableStatus
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/validators/reservationV2.validator.ts